import React from "react"

// Styles
import * as styles from "./Main.module.scss"

const Main = props => {
  function getColorClass() {
    return "color" + (Math.floor(Math.random() * 4) + 1)
  }

  return (
    <div className={`${styles.Main} ${styles[props.theme]}`}>
      <div className={styles.rhombi}>
        <div className={`${styles.rhombusOne} ${getColorClass()}`}></div>
        <div className={`${styles.rhombusTwo} ${getColorClass()}`}></div>
        <div className={`${styles.rhombusThree} ${getColorClass()}`}></div>
        <div className={`${styles.rhombusFour} ${getColorClass()}`}></div>
      </div>
      {props.children}
    </div>
  )
}

export default Main
